
















































































































import { Component, Provide, Vue } from 'vue-property-decorator';
import {
  getPreCollectionByUuid,
  getPreCollectionByUuidWithUser,
} from '@/utils/pre-collection/pre-collection-util';
import CollectionItemStore, {
  CollectionItemStoreInterface,
} from '@/resource/collection-item/collection-item.store';
import { CollectionItemType } from '@/resource/collection-item/collection-item.model';
import { Question } from '@/resource/question/question.model';
import {
  PreCollection,
  PreCollectionContentType,
  PreCollectionType,
} from '@/resource/pre-collection/pre-collection.model';
import NotFound from '@/components/common/NotFound.vue';
import PreCollectionContent from '@/components/pre-collection/PreCollectionContent.vue';
import PreCollectionDetail from '@/components/pre-collection/PreCollectionDetail.vue';
import PreCollectionTitle from '@/components/pre-collection/PreCollectionTitle.vue';
import PreCollectionTitleSmall from '@/components/pre-collection/PreCollectionTitleSmall.vue';
import PreCollectionLoading from '@/components/pre-collection/PreCollectionLoading.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import generatePrecollectionName from '@/utils/common/generate-precollection-name';
import { getPdfDownloaded, getToken, getUserStatus } from '@/utils/cookie';
import { UserStatus } from '@/resource/user/user.model';
import PremiumModal from '@/main-components/premium/PremiumModal.vue';
import ModalSignInUp from '@/main-components/common/modal/ModalSignInUp.vue';
// import AdsenseModal from '@/main-components/adsense/AdsenseModal.vue';
import CourseContent from '@/components/course/CourseContent.vue';
import CourseItemStore, {
  CourseItemStoreInterface,
} from '@/resource/course-item/course-item.store';
import PurchaseStore, {
  PurchaseStoreInterface,
} from '@/resource/purchase/purchase.store';
import CoursePurchasedDetail from '@/components/course/CoursePurchasedDetail.vue';
import CoursePurchasedContent from '@/components/course/CoursePurchasedContent.vue';
import PaperGeneratedItemStore, {
  PaperGeneratedItemStoreInterface,
} from '@/resource/paper-generated-item/paper-generated-item.store';
import PreCollectionPaperGeneratedItems from '@/components/pre-collection/PreCollectionPaperGeneratedItems.vue';
import {
  PaperGeneratedItem,
  PaperGeneratedItemType,
  PaperGeneratedItemsGroup,
  getOrderPaperGeneratedItem,
} from '@/resource/paper-generated-item/paper-generated-item.model';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    NotFound,
    PreCollectionContent,
    PreCollectionPaperGeneratedItems,
    PreCollectionDetail,
    PreCollectionTitle,
    PreCollectionTitleSmall,
    PreCollectionLoading,
    PremiumModal,
    ModalSignInUp,
    // AdsenseModal,
    CourseContent,
    CoursePurchasedDetail,
    CoursePurchasedContent,
  },
  metaInfo(this: PaperCollection): MetaInfo {
    return {
      title: this.metaTitle,
      meta: [
        ...seoDefault({
          title: this.metaTitle + ' Mysoalan',
          description: this.metaDescription,
        }),
      ],
    };
  },
})
export default class PaperCollection extends Vue {
  collectionItemStore: CollectionItemStoreInterface = CollectionItemStore;
  courseItemStore: CourseItemStoreInterface = CourseItemStore;
  paperGeneratedItemStore: PaperGeneratedItemStoreInterface = PaperGeneratedItemStore;
  purchaseStore: PurchaseStoreInterface = PurchaseStore;

  openPremiumModal: any = null;
  openSignInUpModal: any = null;
  openAdsModal: any = null;

  mounted() {
    this.openAdsModal && this.openAdsModal();
  }

  get premiumModalTitle() {
    return this.isCourse
      ? `Jadi pengguna Premium untuk daftar Course ini 🤩`
      : 'Oops! Anda belum melanggan untuk download';
  }

  get premiumModalDescription() {
    return this.isCourse
      ? `Sila langgan pelan <span class="text-brand_dark-primary">premium</span> untuk mendaftar Course ini.`
      : 'Download tanpa had apabila anda melanggan pelan <span class="text-brand_dark-primary">premium</span>.';
  }

  get registerModalDescription() {
    return this.isCourse
      ? `Daftar akaun anda untuk untuk mengguna Course ini.`
      : `Daftar akaun anda untuk memuat turun documen PDF`;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isLoggedin() {
    return getToken() ? true : false;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  get isCourse() {
    return this.currentPreCollection && this.currentPreCollection.course;
  }

  get isPaperGenerated() {
    return (
      this.currentPreCollection && this.currentPreCollection.paperGenerated
    );
  }

  get isReachDownloadLimit() {
    return this.userStatus === UserStatus.Free && getPdfDownloaded() >= 2;
  }

  get isPreviewOnly() {
    if (!this.currentPreCollection) {
      return true;
    }
    return (
      this.userStatus === UserStatus.Free && this.currentPreCollection.isPremium
    );
  }

  get preCollectionUuid() {
    const params = this.$route.params.uuid.split('-');
    return params[params.length - 1] ? params[params.length - 1] : 'not-avail';
  }

  get promoCode() {
    return this.$route.params.code || null;
  }

  get collectionUuid() {
    return (
      (this.currentPreCollection &&
        this.currentPreCollection.collection &&
        this.currentPreCollection.collection.uuid) ||
      ''
    );
  }

  get adminMode(): boolean {
    let adminMode = false;
    if (typeof this.$route.query['admin-mode'] === 'string') {
      const queryIsSubjective = this.$route.query['admin-mode'];

      if (queryIsSubjective) {
        if (queryIsSubjective.toLowerCase() === 'true') {
          adminMode = true;
        } else if (queryIsSubjective.toLowerCase() === 'false') {
          adminMode = false;
        }
      }
    }
    return adminMode;
  }

  get collectionItems() {
    return this.collectionItemStore.collectionItems.map((item, index) => {
      let question: Question = item.questionObjective;
      let isObjective = true;

      if (item.collectionItemType === CollectionItemType.Subjective) {
        question = item.questionSubjective;
        isObjective = false;
      }

      return {
        id: item.id,
        question,
        isObjective,
        languages: item.languages,
        type: item.collectionItemType,
        title: item.title,
        number: isObjective ? index : index - 1,
        answerPosition: isObjective ? item.answerPosition : 0,
      };
    });
  }

  get paperGeneratedItemsGroups() {
    const paperGeneratedItemsGroups: PaperGeneratedItemsGroup[] = [];

    let currentOrder = 1;
    let currentParentOrder: number | null = null;
    let currentSubOrder = 1;

    this.paperGeneratedItemStore.paperGeneratedItems.map(paperGeneratedItem => {
      const { parentOrder, isSubOrder } = getOrderPaperGeneratedItem(
        paperGeneratedItem.order,
      );

      if (
        parentOrder &&
        currentParentOrder &&
        parentOrder === currentParentOrder
      ) {
        // NOTE: add all suborder to groupQuestion
        const subPaperGeneratedItem: PaperGeneratedItem = {
          ...paperGeneratedItem,
          newQuestionGenerateds: [],
          selectedNewQuestionGenerated: null,
          hasChange: false,
          subOrder: null,
        };

        if (paperGeneratedItem.type === PaperGeneratedItemType.Question) {
          subPaperGeneratedItem.subOrder = currentSubOrder;
          currentSubOrder += 1;
        }

        paperGeneratedItemsGroups[parentOrder - 1].paperGeneratedItems.push(
          subPaperGeneratedItem,
        );
      } else {
        // NOTE: for normal paperGeneratedItem but groupQuestion is not empty coz of prev

        const currentPaperGeneratedItem: PaperGeneratedItem = {
          ...paperGeneratedItem,
          newQuestionGenerateds: [],
          selectedNewQuestionGenerated: null,
          hasChange: false,
          subOrder: null,
        };

        const paperGeneratedItemsGroup: PaperGeneratedItemsGroup = {
          order: null,
          paperGeneratedItems: [currentPaperGeneratedItem],
        };

        if (isSubOrder) {
          currentSubOrder = 1;
          if (paperGeneratedItem.type === PaperGeneratedItemType.Question) {
            currentPaperGeneratedItem.subOrder = currentSubOrder;
            currentSubOrder += 1;
          }

          currentParentOrder = parentOrder;
          paperGeneratedItemsGroup.order = currentOrder;
          currentOrder += 1;
        } else {
          currentParentOrder = null;
        }

        if (
          !currentParentOrder &&
          paperGeneratedItem.type === PaperGeneratedItemType.Question
        ) {
          paperGeneratedItemsGroup.order = currentOrder;
          currentOrder += 1;
        }

        paperGeneratedItemsGroups.push(paperGeneratedItemsGroup);
      }
    });

    return paperGeneratedItemsGroups;
  }

  get isLastPaperGeneratedItem() {
    return (
      this.paperGeneratedItemStore.pagination.page >=
      this.paperGeneratedItemStore.pagination.totalPages
    );
  }

  get lastObjectiveQuestion() {
    return this.collectionItemStore.lastObjectiveQuestion;
  }

  get totalSubjectiveQuestions() {
    return this.collectionItemStore.totalSubjectiveQuestions;
  }

  get isPdfAvail(): boolean {
    if (this.currentPreCollection) {
      return this.currentPreCollection.pdfLink ? true : false;
    } else {
      return true;
    }
  }

  get courseItems() {
    return this.courseItemStore.courseItems;
  }

  get sessionQuery() {
    let sessionQuery = '';
    if (typeof this.$route.query['session'] === 'string') {
      sessionQuery = this.$route.query['session'];
    }
    return sessionQuery;
  }

  get metaTitle() {
    if (this.currentPreCollection) {
      return generatePrecollectionName(this.currentPreCollection) + ' |';
    } else {
      return 'Paper |';
    }
  }

  get metaDescription() {
    if (this.currentPreCollection) {
      const preName =
        this.currentPreCollection.type === PreCollectionType.Exam
          ? 'Exam paper'
          : 'Practice paper';

      return (
        this.currentPreCollection.name +
        ' ' +
        preName +
        ' for ' +
        this.currentPreCollection.subject.name +
        `. Download it or duplicate as your collection now!`
      );
    } else {
      return 'Find all the popular exams & practice papers compiled here. The paper is a collection of questions for exam papers that is ready to be printed.';
    }
  }

  isLoading = true;
  isLoadingAddCollectionItems = false;
  isDetailLoading = false;
  isPurchased = false;
  currentPreCollection: PreCollection | null = null;
  courseProgress = 0;
  screenWidth = 0;
  pdfDownloaded = 0;

  fetchPdfDownloaded() {
    this.pdfDownloaded = getPdfDownloaded();
  }

  beforeCreate() {
    this.$timeMpEvent(this.$mp_value.LoadTimePreCollection);
  }

  async created() {
    this.fetchPdfDownloaded();

    window.addEventListener('resize', this.getScreenWidth);
    this.getScreenWidth();

    if (this.preCollectionUuid) {
      await this.fetchPreCollection(this.preCollectionUuid);

      // To check if the url is from stripe redirection before sending MP EVENT
      if (this.sessionQuery && this.currentPreCollection) {
        this.$sendMpEvent({
          event: this.$mp_value.PurchaseSuccess,
          properties: {
            uuid: this.currentPreCollection.uuid,
            name: this.currentPreCollection.name,
            type: this.currentPreCollection.type,
            price: parseFloat(this.sessionQuery),
          },
        });
      }
      // ----------------------------------------------------------------------

      if (
        !this.isPdfAvail &&
        this.currentPreCollection &&
        this.currentPreCollection.collection
      ) {
        this.collectionItemStore.updateCollectionManually(
          this.currentPreCollection.collection,
        );
        await this.fetchCollectionItem();
        await this.scrollBottom();

        this.$sendMpEvent({
          event: this.$mp_value.LoadTimePreCollection,
          properties: {
            contentType: PreCollectionContentType.Collection,
          },
        });
      }

      if (this.currentPreCollection && this.isPaperGenerated) {
        await this.fetchPaperGeneratedItem();
        await this.scrollBottomPaperGenerated();

        this.$sendMpEvent({
          event: this.$mp_value.LoadTimePreCollection,
          properties: {
            contentType: PreCollectionContentType.PaperGenerated,
          },
        });
      }

      if (this.currentPreCollection) {
        if (this.currentPreCollection.course) {
          await this.courseItemStore.fetchCourseItemsByCourse(
            this.currentPreCollection.course.uuid,
          );

          await this.purchaseStore.fetchOnePurchaseByPreCollectionUuid(
            this.currentPreCollection.uuid,
          );

          if (this.purchaseStore.purchase) {
            this.isPurchased = true;
          }

          this.$sendMpEvent({
            event: this.$mp_value.LoadTimePreCollection,
            properties: {
              contentType: PreCollectionContentType.Course,
            },
          });
        }

        this.$sendMpEvent({
          event: this.$mp_value.PremadePaperView,
          properties: {
            uuid: this.currentPreCollection.uuid,
            name: this.currentPreCollection.name,
            form: this.currentPreCollection.form,
            type: this.currentPreCollection.type,
            year: this.currentPreCollection.year,
            subjectUuid: this.currentPreCollection.subject.uuid,
            isPremium: this.currentPreCollection.isPremium,
            isReachDownloadLimit: this.isReachDownloadLimit,
            contentType: this.currentPreCollection.course
              ? PreCollectionContentType.Course
              : this.currentPreCollection.pdfLink
              ? PreCollectionContentType.Pdf
              : this.currentPreCollection.collection
              ? PreCollectionContentType.Collection
              : PreCollectionContentType.PaperGenerated,
          },
        });
      }

      this.isLoading = false;
    }
  }

  beforeDestroy() {
    // NOTE: Unmount sroll bottom to fetch data
    window.removeEventListener('resize', this.getScreenWidth);
    window.onscroll = async () => {
      return;
    };
  }

  async fetchPreCollection(uuid: string) {
    try {
      if (this.isLoggedin) {
        this.currentPreCollection = await getPreCollectionByUuidWithUser(uuid);
      } else {
        this.currentPreCollection = await getPreCollectionByUuid(uuid);
      }
    } catch (err) {
      this.currentPreCollection = null;
    }
  }

  async fetchCollectionItem() {
    if (!this.collectionUuid) return;

    this.collectionItemStore.pagination.isResetPage = true;
    this.collectionItemStore.pagination.page = 1;
    await this.collectionItemStore.fetchCollectionItems(this.collectionUuid);
  }

  async fetchPaperGeneratedItem() {
    if (!this.currentPreCollection) return;

    this.paperGeneratedItemStore.pagination.isResetPage = true;
    this.paperGeneratedItemStore.pagination.page = 1;
    await this.paperGeneratedItemStore.fetchPaperGeneratedItems(
      this.currentPreCollection.paperGenerated,
    );
  }

  async createPdfByCollection() {
    if (this.isLoading || this.isLoadingAddCollectionItems) return;

    await this.collectionItemStore.createPdf();

    if (this.collectionItemStore.pdfFile) {
      const blob = new Blob([this.collectionItemStore.pdfFile], {
        type: 'application/pdf',
      });

      return blob;
    }
  }

  async createPdfByPaperGenerated() {
    if (
      this.isLoading ||
      this.isLoadingAddCollectionItems ||
      !this.currentPreCollection
    )
      return;

    await this.paperGeneratedItemStore.createPdf(
      this.currentPreCollection.paperGenerated,
    );

    if (this.paperGeneratedItemStore.pdfFile) {
      const blob = new Blob([this.paperGeneratedItemStore.pdfFile], {
        type: 'application/pdf',
      });

      return blob;
    }
  }

  updateIsDetailLoading(status: boolean) {
    this.isDetailLoading = status;
  }

  async scrollBottom() {
    window.onscroll = async () => {
      const { pagination } = this.collectionItemStore;

      if (this.isPdfAvail) return;

      if (this.isReachDownloadLimit) return;

      if (
        this.isLoading ||
        this.isLoadingAddCollectionItems ||
        pagination.page >= pagination.totalPages
      ) {
        return;
      }

      if (!this.isPremiumStatus || !this.isLoggedin) {
        return;
      }

      const bottomOfWindow =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop,
        ) +
          window.innerHeight +
          200 >=
        document.documentElement.scrollHeight;

      if (!bottomOfWindow) {
        return;
      } else {
        this.collectionItemStore.pagination.page += 1;

        this.isLoadingAddCollectionItems = true;

        await this.collectionItemStore.fetchCollectionItems(
          this.collectionUuid,
        );

        this.isLoadingAddCollectionItems = false;
      }
    };
  }

  async scrollBottomPaperGenerated() {
    window.onscroll = async () => {
      const { pagination } = this.paperGeneratedItemStore;

      if (this.isReachDownloadLimit || !this.currentPreCollection) return;

      if (
        this.isLoading ||
        this.isLoadingAddCollectionItems ||
        pagination.page >= pagination.totalPages
      ) {
        return;
      }

      if (!this.isPremiumStatus || !this.isLoggedin) {
        return;
      }

      const bottomOfWindow =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop,
        ) +
          window.innerHeight +
          200 >=
        document.documentElement.scrollHeight;

      if (!bottomOfWindow) {
        return;
      } else {
        this.paperGeneratedItemStore.pagination.page += 1;

        this.isLoadingAddCollectionItems = true;

        await this.paperGeneratedItemStore.fetchPaperGeneratedItems(
          this.currentPreCollection.paperGenerated,
        );

        this.isLoadingAddCollectionItems = false;
      }
    };
  }

  updatecourseProgress(courseProgress: number) {
    this.courseProgress = courseProgress;
  }

  openPremiumModalAdd(openModal: any) {
    this.openPremiumModal = openModal;
  }

  openSignInUpModalAdd(openModal: any) {
    this.openSignInUpModal = openModal;
  }

  openModalAds(openModal: any) {
    this.openAdsModal = openModal;
  }

  refreshPage() {
    this.$router.go(0);
  }

  getScreenWidth() {
    this.screenWidth = window.innerWidth;
  }

  @Provide('openPremiumPlanModal')
  async openPremiumPlanModal() {
    this.openPremiumModal && this.openPremiumModal();
  }

  @Provide('openRegisterModal')
  async openRegisterModal() {
    this.openSignInUpModal && this.openSignInUpModal();
  }
}
